import { Text } from "@mantine/core";

export const MetaLabel = ({ children, c = "dimmed", width = "30%" }) => {
    return (
      <Text size="sm" style={{ width: width }} fw={500} c={c}>
        {children}
      </Text>
    );
  };